var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyTransition',{attrs:{"myName":'up'}},[(_vm.popupStatus)?_c('Popup',[(_vm.popup == 'check')?_c('PopupCheck',{attrs:{"text":_vm.successText},on:{"go":_vm.popupAction,"cancel":_vm.poupupEnter}}):_vm._e(),(_vm.popup == 'success')?_c('PopupSuccess',{attrs:{"text":_vm.successText},on:{"check":_vm.poupupEnter}}):_vm._e(),(_vm.popup == 'error')?_c('PopupError',{attrs:{"text":_vm.successText},on:{"check":_vm.poupupEnter}}):_vm._e()],1):_vm._e()],1),(_vm.$route.path === '/admin/new_construction')?_c('div',{staticClass:"search_block"},[_c('Search',{attrs:{"filed":_vm.searchField,"searchAction":_vm.searchAction,"searchStatus":_vm.searchStatus}})],1):_vm._e(),_c('div',{staticClass:"costruction table_outter_block",staticStyle:{"height":"calc(100vh - 100px)"}},[(!_vm.$route.path.includes('new_construction_finished'))?_c('div',{staticClass:"update_btn flex flex_end"},[_c('button',{staticClass:"btn_warning",on:{"click":_vm.updateUOF}},[_c('i',{staticClass:"el-icon-refresh-left"}),_vm._v("更新UOF狀態 ")])]):_vm._e(),_c('Loading',{attrs:{"part":""}}),(_vm.tableData.length !== 0)?_c('div',[_c('PersonalTable',[_c('TableThead',{attrs:{"slot":"thead","thead":_vm.clearThead,"thead_scroll":_vm.thead_scroll},on:{"tableSort":_vm.tableSort,"eventGetHeight":_vm.eventGetHeight},slot:"thead"}),_c('div',{staticClass:"personal_data_table",style:(`top:${_vm.table_head_heigh}px;  height:calc(100vh - ${330 - _vm.table_head_heigh
    }px);`),attrs:{"slot":"tbody"},on:{"scroll":_vm.scrollEvent},slot:"tbody"},[_c('table',[_c('colgroup',_vm._l((_vm.clearThead),function(th,index){return _c('col',{key:index,attrs:{"width":th.width}})}),0),_c('tbody',[_vm._l((_vm.pageData),function(data,index){return [_c('tr',{key:`application_${index}`,class:_vm.finishCase(data)},[_vm._l((_vm.clearThead),function(th,th_index){return [(th.value == 'info')?_c('td',{key:`info_${th_index}`,class:th.align == 'center'
    ? 'text_center'
    : false},[_c('el-button',{staticClass:"info_icon",attrs:{"type":"text"},on:{"click":function($event){return _vm.openWork(data, index)}}},[_c('i',{staticClass:"el-icon-more"})])],1):(th.value ==
    'vendors.vendor_chinese'
    )?_c('td',{key:`vendor_chinese_${th_index}`,class:th.align == 'center'
    ? 'text_center'
    : false},_vm._l((data.vendors),function(item){return _c('p',{key:item.vendor_chinese},[_vm._v(" "+_vm._s(item.vendor_chinese)+" ")])}),0):(th.value == 'link')?_c('td',{key:`uof_${th_index}`,staticClass:"uof_link",class:th.align == 'center'
    ? 'text_center'
    : false,on:{"click":function($event){return _vm.openOrder(data)}}},[_c('button',{staticClass:"icon_btn btn_primary"},[_c('i',{staticClass:"el-icon-link"})])]):(th.value == 'status')?_c('td',{key:`state_${th_index}`,class:th.align == 'center'
    ? 'text_center'
    : false},[(data.status == '同意')?[_c('p',{staticClass:"blue"},[_c('i',{staticClass:"el-icon-success"})])]:[_c('i',{staticClass:"el-icon-error"})]],2):(data[th.value] &&
    Array.isArray(
      data[th.value]
    )
    )?_c('td',{key:`array_${th_index}`,staticClass:"table_array",class:th.align == 'center'
    ? 'text_center'
    : false},_vm._l((data[
    th.value
    ]),function(item){return _c('p',{key:item},[_vm._v(" "+_vm._s(_vm.labelTransform({ key: th.value.split( "_" )[0], data: item, inner_key: [ "id", "vendor_id", ], }))+" ")])}),0):(th.value.includes('.')
    )?_c('td',{key:`object_${th_index}`},[_vm._v(" "+_vm._s(_vm.transfromData( data, th.value ))+" ")]):_c('td',{key:`data_${th_index}`,class:th.align == 'center'
      ? 'text_center'
      : false},[_vm._v(" "+_vm._s(data[th.value])+" ")])]})],2),_c('el-dialog',{attrs:{"top":"7vh","show-close":false,"visible":_vm.check_inner_status[index].status},on:{"close":function($event){return _vm.openWork(data, index)},"update:visible":function($event){return _vm.$set(_vm.check_inner_status[index], "status", $event)}}},[(_vm.check_inner_status[index]
    .status == true &&
    _vm.check_inner_status[index]
      .status_index == index
    )?_c('tr',{key:`daliy_${index}`,staticClass:"table_second"},[_c('td',[_c('div',{staticClass:"table_second__innerbox"},_vm._l((_vm.clearInnerThead),function(inner_thead,inner_thead_index){return _c('div',{key:inner_thead_index,staticClass:"item",class:inner_thead.dependent
    ? false
    : 'independent'},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(inner_thead.name)+" ")]),(inner_thead.value ==
    'link'
    )?[_c('button',{staticClass:"btn_border",on:{"click":function($event){return _vm.openOrder(
      data
    )}}},[_c('i',{staticClass:"el-icon-link"})])]:(inner_thead.value ==
    'employee'
    )?[_vm._v(" "+_vm._s(data.employee .name)+" ")]:(inner_thead.value ==
    'area'
    )?_vm._l((_vm.transfromData(
    data,
    inner_thead.value
  )),function(area){return _c('p',[_c('i',{staticClass:"el-icon-caret-right"}),_vm._v(" "+_vm._s(area)+" ")])}):(inner_thead.value ==
    'vendors'
    )?_vm._l((data.vendors),function(item,index){return _c('p',{key:`vendor_${index}`,staticClass:"inner_name"},[_vm._v(" "+_vm._s(item.vendor_chinese)+" / "+_vm._s(item .supervisor .name)+" ")])}):(inner_thead.value ==
    'visitors'
    )?_vm._l((data[
    inner_thead
      .value
  ]),function(item){return _c('p',{key:item.name},[_vm._v(" "+_vm._s(item.name)+" ")])}):(inner_thead.value ==
    'files'
    )?[(data.status ==
    '同意'
    )?_c('div',{staticClass:"item"}):_vm._e(),(Object.keys(
    data.commit
  ).length !=
    0
    )?_c('div',{staticClass:"item flex flex_align_center"},[_c('div',{staticClass:"inner_name"},[_vm._v(" 協議組織規範事項 ")]),(Object.keys(
    data.commit
  )
    .length !==
    0
    )?_c('button',{staticClass:"icon_btn btn_border",on:{"click":function($event){return _vm.defaultRouter(
      'new_commit',
      {
        work_id:
          data
            .commit
            .id,
        new_work_id:
          data
            .commit
            .new_work_id,
      }
    )}}},[_c('i',{staticClass:"el-icon-document"})]):_c('div',[_vm._v(" - ")])]):_c('div',[_vm._v("--")]),(_vm.is_role ==
    'manager'
    )?_c('div',{staticClass:"item upload_box"},[_c('input',{attrs:{"type":"file","id":`${index}_${inner_thead_index}`,"multiple":""},on:{"change":function($event){return _vm.upload(
      $event,
      `${index}_${inner_thead_index}`,
      data.id
    )}}}),_c('label',{staticClass:"upload_UI_finish",attrs:{"for":`${index}_${inner_thead_index}`}},[_c('i',{staticClass:"el-icon-upload2"}),_vm._v("上傳備註文件")])]):_vm._e(),(_vm.is_role ==
    'manager'
    )?_vm._l((data[
    'attachment'
  ]),function(f,f_index){return _c('div',{key:f_index,staticClass:"item attachment flex"},[_c('div',{staticClass:"inner_name"},[_vm._v(" "+_vm._s(f.filename)+" ")]),_c('button',{staticClass:"icon_btn btn_border",on:{"click":function($event){return _vm.link(
    `${f.path}`
  )}}},[_c('i',{staticClass:"el-icon-document"})]),_c('button',{staticClass:"icon_btn btn_error",on:{"click":function($event){return _vm.deleteFile(
      data.id,
      f.id
    )}}},[_c('i',{staticClass:"el-icon-delete-solid"})])])}):_vm._e()]:(inner_thead.value ==
    'dailys'
    )?[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"the_day_list"},_vm._l((data.dailys),function(the_day,day_index){return _c('div',{key:`dailys_${day_index}`,staticClass:"flex list_item flex_align_center"},[_c('div',{staticClass:"the_day"},[(the_day.is_finished ===
    1
    )?_c('span',[_c('i',{staticClass:"el-icon-success"})]):_vm._e(),_vm._v(" "+_vm._s(the_day.date)+" "),(the_day
      .visitors
      .length >
    0
    )?_c('div',{staticClass:"daily_works_finished"},[_c('div',{staticClass:"item upload_box"},[_c('input',{attrs:{"type":"file","disabled":_vm.findUpload_files(
    '每日巡檢表',
    the_day
  ),"id":`每日巡檢表_${the_day.date}`},on:{"change":function($event){return _vm.uploadFinished(
      $event,
      '每日巡檢表',
      the_day.id
    )}}}),_c('label',{staticClass:"upload_UI_finish",attrs:{"for":`每日巡檢表_${the_day.date}`}},[(_vm.findUpload_files(
    '每日巡檢表',
    the_day
  ) &&
    the_day.daily_check
    )?_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" 每日巡檢表: "),_c('div',{staticClass:"attachment"},[_c('button',{staticClass:"icon_btn btn_border",on:{"click":function($event){return _vm.link(
      `${the_day.daily_check.path}`
    )}}},[_c('i',{staticClass:"el-icon-document"})]),_c('button',{staticClass:"icon_btn btn_error",on:{"click":function($event){return _vm.deleteFile(
      the_day.id,
      the_day
        .daily_check
        .id
    )}}},[_c('i',{staticClass:"el-icon-delete-solid"})])])]):_c('div',[_c('i',{staticClass:"el-icon-upload2"}),_vm._v("上傳 每日巡檢文件 ")])])]),(the_day.cancel_op ===
    0 &&
    the_day.op ===
    1
    )?_c('div',{staticClass:"item upload_box"},[_c('input',{attrs:{"type":"file","disabled":_vm.findUpload_files(
    '危險作業檢查表',
    the_day
  ),"id":`危險作業檢查表_${the_day.date}`},on:{"change":function($event){return _vm.uploadFinished(
      $event,
      '危險作業檢查表',
      the_day.id
    )}}}),_c('label',{staticClass:"upload_UI_finish",attrs:{"for":`危險作業檢查表_${the_day.date}`}},[(_vm.findUpload_files(
    '危險作業檢查表',
    the_day
  ) &&
    the_day.danger_check
    )?_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" 危險作業檢查表: "),_c('div',{staticClass:"attachment"},[_c('button',{staticClass:"icon_btn btn_border",on:{"click":function($event){return _vm.link(
      `${the_day.danger_check.path}`
    )}}},[_c('i',{staticClass:"el-icon-document"})]),_c('button',{staticClass:"icon_btn btn_error",on:{"click":function($event){return _vm.deleteFile(
      the_day.id,
      the_day
        .danger_check
        .id
    )}}},[_c('i',{staticClass:"el-icon-delete-solid"})])])]):_c('div',[_c('i',{staticClass:"el-icon-upload2"}),_vm._v("上傳 危險作業檢查表 ")])])]):_vm._e()]):_vm._e()]),_c('div',{staticClass:"the_day_detail"},_vm._l((_vm.dailyInnerThead),function(daily_inner_thead,daily_inner_thead_index){return _c('div',{key:daily_inner_thead_index,staticClass:"item flex flex_column",class:daily_inner_thead.dependent
    ? false
    : 'independent'},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(daily_inner_thead.name)+" ")]),_c('div',[(daily_inner_thead.value ==
    'toolbox' &&
    data.status ==
    '同意'
    )?[_c('div',{staticClass:"item flex flex_align_center"},[_c('div',{staticClass:"inner_name"},[_vm._v(" 每日工具箱會議及危害告知紀錄 ")]),(Object.keys(
    data.commit
  )
    .length !==
    0
    )?_c('button',{staticClass:"icon_btn btn_border",on:{"click":function($event){return _vm.defaultRouter(
      'new_toolbox',
      {
        work_id:
          the_day
            .toolbox
            .id,
        new_work_id:
          the_day.new_work_id,
        toolbox_id:
          the_day
            .toolbox
            .daily_id,
      }
    )}}},[_c('i',{staticClass:"el-icon-document"})]):_c('div',[_vm._v(" - ")])])]:(daily_inner_thead.value ==
    'visitors' &&
    data.status ==
    '同意'
    )?[_c('div',{staticClass:"item flex"},[(the_day
    .visitors
    .length >
    0
    )?_c('i',{staticClass:"el-icon-success"}):_c('i',{staticClass:"el-icon-error"})])]:(daily_inner_thead.value ==
    'op'
    )?[_vm._v(" "+_vm._s(the_day.op == 1 ? "是" : "否")+" ")]:(daily_inner_thead.value ==
    'op_id' &&
    the_day.op ==
    1
    )?_vm._l((the_day.op_id),function(item,index){return _c('div',{key:`op_${index}`},[_c('i',{staticClass:"el-icon-caret-right"}),_vm._v(" "+_vm._s(item)+" ")])}):(daily_inner_thead.value ==
    'clean'
    )?[_vm._v(" "+_vm._s(the_day.clean == 1 ? "是" : "否")+" ")]:(daily_inner_thead.value ==
    'clean_list' &&
    the_day.clean ==
    1
    )?_vm._l((the_day.clean_list),function(item){return _c('p',[_c('i',{staticClass:"el-icon-caret-right"}),_vm._v(" "+_vm._s(item)+" ")])}):(daily_inner_thead.value ==
    'environment'
    )?[_vm._v(" "+_vm._s(the_day.environment == 1 ? "是" : "否")+" ")]:(daily_inner_thead.value ==
    'environment_list' &&
    the_day.environment ==
    1
    )?_vm._l((the_day.environment_list),function(item){return _c('p',[_c('i',{staticClass:"el-icon-caret-right"}),_vm._v(" "+_vm._s(item)+" ")])}):(daily_inner_thead.value ==
    'op_cancel' &&
    the_day.op ===
    1
    )?[_vm._v("否 "),_c('el-switch',{attrs:{"disabled":the_day.cancel_op ===
    1,"value":the_day.cancel_op,"active-value":1,"inactive-value":0,"active-color":"#13ce66","inactive-color":"#ff4949"},on:{"change":function($event){return _vm.cancelOP(
      the_day
    )}}}),_vm._v(" 是 "),(the_day.cancel_op ===
    1
    )?_c('p',[_vm._v(" 取消: "+_vm._s(_vm.$moment().format( "YYYY-MM-DD h:mm:ss a" ))+" ")]):_vm._e()]:_vm._e()],2)])}),0)])}),0)])]:(inner_thead.value.includes(
    '.'
  )
    )?[_vm._v(" "+_vm._s(_vm.transfromData( data, inner_thead.value ))+" ")]:(data[
    inner_thead
      .value
    ] &&
    Array.isArray(
      data[
      inner_thead
        .value
      ]
    )
    )?_vm._l((data[
    inner_thead
      .value
    ]),function(item,index){return _c('p',{key:`innerThead_${item}`},[_c('i',{staticClass:"el-icon-caret-right"}),_vm._v(" "+_vm._s(_vm.labelTransform( { key: inner_thead.value.split( "_" )[0], data: item, inner_key: [ "id", "op_id", ], } ))+" ")])}):[_vm._v(" "+_vm._s(data[ inner_thead .value ])+" ")]],2)}),0)])]):_vm._e()])]})],2)])])],1),_c('el-pagination',{attrs:{"page-size":_vm.page.size + 1,"pager-count":11,"layout":"prev, pager, next","total":_vm.page.allPage},on:{"current-change":_vm.pageChange}})],1):(this.$store.state.loading == false)?_c('div',{staticClass:"no_data"},[_c('i',{staticClass:"el-icon-warning-outline"}),_c('p',[_vm._v("NO Data")])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }